/**
 * Firefox-compatible date parsing utility
 * Handles month-year strings like "January 2025" that Firefox struggles with
 */
export function parseDateString(dateStr) {
    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'];
    
    const parts = dateStr.split(' ');
    if (parts.length === 2) {
        const monthIndex = monthNames.indexOf(parts[0]);
        const year = parseInt(parts[1]);
        if (monthIndex !== -1 && !isNaN(year)) {
            return new Date(year, monthIndex, 1);
        }
    }
    
    // Fallback to original parsing
    return new Date(dateStr);
}

/**
 * Sort tiles by date in descending order (newest first)
 */
export function sortTilesByDate(tiles) {
    return tiles.sort((a, b) => {
        return parseDateString(b.title) - parseDateString(a.title);
    });
}
